/**
 * @template T
 * @callback Sort
 * @param {T} a
 * @param {T} b
 */

/**
 * @template T
 * @param {keyof T} field
 * @returns {Sort<T>}
 */
const alphabetically = (field) => {
  /**
   * @template T
   * @type {Sort<T>}
   */
  return (a, b) => {
    if (a[field] < b[field]) {
      return -1;
    }

    return a[field] > b[field] ? 1 : 0;
  };
};

/**
 * @param {string} s
 * @returns {import("./types/type").Url}
 */
const s2Url = (s) => /** @type {import("./types/type").Url} */ (s);

/**
 * @param {string} s
 * @returns {import("./types/type").GameId}
 */
const s2GameId = (s) => /** @type {import("./types/type").GameId} */ (s);

/**
 * @param {string} s
 * @returns {import("./types/type").UserId}
 */
const s2UserId = (s) => /** @type {import("./types/type").UserId} */ (s);

export { alphabetically, s2GameId, s2Url, s2UserId };
